// src/pages/Wallet.jsx
import { useState } from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';
import { C } from '../styles/tokens';

const TRANSACTIONS = [
  { type: 'in',  label: 'Job Completion Bonus',    amount: '+200 ONT', date: 'Jan 14, 2025', hash: '3xKp...9mNq', note: 'TechFlow Global'      },
  { type: 'in',  label: 'Referral Bonus',          amount: '+50 ONT',  date: 'Jan 12, 2025', hash: '7rLm...4wQs', note: 'Referred: James O.'   },
  { type: 'out', label: 'Training Enrollment',     amount: '-30 ONT',  date: 'Jan 10, 2025', hash: '9pNx...2kRt', note: 'React Advanced Course' },
  { type: 'in',  label: 'Welcome Bonus',           amount: '+100 ONT', date: 'Jan 5, 2025',  hash: '2mYz...6jBv', note: 'Platform Signup'       },
  { type: 'out', label: 'Portfolio Boost Feature', amount: '-15 ONT',  date: 'Jan 3, 2025',  hash: '5wDa...8cFp', note: 'Premium Feature'       },
];

function ActionModal({ action, onClose }) {
  if (!action) return null;
  const titles = { send: 'Send ONT Tokens', receive: 'Receive ONT Tokens', convert: 'Convert to USDT', withdraw: 'Withdraw Funds' };
  return (
    <div onClick={e => e.target === e.currentTarget && onClose()} style={{ position:'fixed', inset:0, zIndex:500, background:'rgba(4,4,15,.92)', backdropFilter:'blur(14px)', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ width:'100%', maxWidth:400, background:C.surface2, border:'1px solid rgba(254,52,232,.2)', borderRadius:18, padding:'clamp(20px,5vw,28px)', animation:'fadeUp .35s cubic-bezier(.16,1,.3,1)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:22 }}>
          <h3 className="syne" style={{ fontSize:'clamp(15px,4vw,18px)', fontWeight:800 }}>{titles[action]}</h3>
          <button onClick={onClose} style={{ background:'rgba(255,255,255,.07)', border:'none', color:'white', width:28, height:28, borderRadius:7, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
        </div>
        {action === 'receive' ? (
          <div style={{ textAlign:'center' }}>
            <div style={{ padding:'16px', background:'rgba(255,255,255,.04)', borderRadius:12, border:'1px solid rgba(255,255,255,.08)', marginBottom:16, fontFamily:'monospace', fontSize:13, color:'rgba(255,255,255,.7)', wordBreak:'break-all' }}>
              7xKp3r8Lm9mNq4wQsT2kRtYpBvDaFp6c
            </div>
            <p style={{ fontSize:12, color:'rgba(255,255,255,.38)' }}>Share this address to receive ONT tokens</p>
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
            {action === 'send' && <div><label style={{ fontSize:11, fontWeight:700, color:'rgba(255,255,255,.45)', display:'block', marginBottom:6 }}>RECIPIENT WALLET ADDRESS</label><input placeholder="Enter Solana wallet address" style={{ width:'100%', padding:'13px 14px', background:'rgba(255,255,255,.04)', border:'1px solid rgba(254,52,232,.2)', borderRadius:9, color:'#fff', fontSize:14, outline:'none', boxSizing:'border-box' }} /></div>}
            <div><label style={{ fontSize:11, fontWeight:700, color:'rgba(255,255,255,.45)', display:'block', marginBottom:6 }}>AMOUNT (ONT)</label><input type="number" placeholder="0" style={{ width:'100%', padding:'13px 14px', background:'rgba(255,255,255,.04)', border:'1px solid rgba(254,52,232,.2)', borderRadius:9, color:'#fff', fontSize:14, outline:'none', boxSizing:'border-box' }} /></div>
            {action === 'convert' && <div style={{ padding:'12px 14px', borderRadius:9, background:'rgba(245,158,11,.08)', border:'1px solid rgba(245,158,11,.2)' }}><p style={{ fontSize:12, color:C.warning }}>1 ONT ≈ $0.15 USDT · Network fee: ~0.001 SOL</p></div>}
            <button style={{ padding:'13px', background:`linear-gradient(135deg,${C.magenta},${C.violet})`, border:'none', borderRadius:9, color:'#fff', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'Syne',sans-serif" }}>Confirm {titles[action]}</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default function Wallet() {
  const [copied, setCopied] = useState(false);
  const [action, setAction] = useState(null);

  return (
    <DashboardLayout title="ONT Wallet" subtitle="Manage your Oracle Nexus Token balance">
      <style>{`
        .wallet-layout {
          display: grid;
          grid-template-columns: 1fr 360px;
          gap: 20px;
        }
        .wallet-actions-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1px;
          background: rgba(255,255,255,.04);
        }
        @media (max-width: 900px) {
          .wallet-layout { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 480px) {
          .wallet-actions-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>

      <div className="wallet-layout">
        {/* Left */}
        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
          {/* Balance card */}
          <div className="card" style={{ padding:0, overflow:'hidden' }}>
            <div style={{ padding:'clamp(20px,4vw,28px)', background:`linear-gradient(135deg,${C.navy}80,${C.violet}40)`, position:'relative', overflow:'hidden' }}>
              <div style={{ position:'absolute', top:-50, right:-50, width:180, height:180, borderRadius:'50%', background:`${C.magenta}12`, filter:'blur(40px)' }} />
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20, position:'relative' }}>
                <div>
                  <div style={{ fontSize:11, color:'rgba(255,255,255,.4)', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', marginBottom:6 }}>Total Balance</div>
                  <div className="syne" style={{ fontSize:'clamp(28px,5vw,42px)', fontWeight:800, lineHeight:1 }}>1,240 <span style={{ fontSize:'clamp(14px,2vw,18px)', color:C.magenta }}>ONT</span></div>
                  <div style={{ fontSize:13, color:'rgba(255,255,255,.4)', marginTop:4 }}>≈ $186.00 USDT</div>
                </div>
                <div style={{ width:52, height:52, borderRadius:14, background:`linear-gradient(135deg,${C.magenta},${C.violet})`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, flexShrink:0 }}>🪙</div>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px', background:'rgba(0,0,0,.25)', borderRadius:10, position:'relative' }}>
                <span style={{ fontSize:12, color:'rgba(255,255,255,.45)', flex:1, fontFamily:'monospace', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>7xKp3r8Lm9mNq4wQsT</span>
                <button onClick={() => { setCopied(true); navigator.clipboard?.writeText('7xKp3r8Lm9mNq4wQsT2kRt'); setTimeout(() => setCopied(false), 2000); }} style={{ fontSize:11, padding:'4px 10px', background: copied ? 'rgba(0,208,132,.2)' : 'rgba(255,255,255,.1)', border:'none', borderRadius:6, color: copied ? C.success : 'white', cursor:'pointer', fontWeight:600, transition:'all .2s', flexShrink:0 }}>{copied ? '✓ Copied' : 'Copy'}</button>
              </div>
            </div>
            {/* Action buttons */}
            <div className="wallet-actions-grid">
              {[['⬆️','Send','send'],['⬇️','Receive','receive'],['🔄','Convert','convert'],['↗️','Withdraw','withdraw']].map(([ic,lb,act]) => (
                <button key={lb} onClick={() => setAction(act)} style={{ padding:'16px 8px', background:C.surface2, border:'none', color:'white', cursor:'pointer', display:'flex', flexDirection:'column', alignItems:'center', gap:4, transition:'background .2s' }} onMouseEnter={e => e.currentTarget.style.background=C.surface3} onMouseLeave={e => e.currentTarget.style.background=C.surface2}>
                  <span style={{ fontSize:20 }}>{ic}</span>
                  <span style={{ fontSize:11, fontWeight:600, color:'rgba(255,255,255,.5)' }}>{lb}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Transaction history */}
          <div className="card" style={{ padding:'clamp(18px,3vw,24px)' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18 }}>
              <h3 className="syne" style={{ fontSize:16, fontWeight:700 }}>Transaction History</h3>
              <span style={{ fontSize:12, color:C.magenta, cursor:'pointer', whiteSpace:'nowrap' }}>Export CSV</span>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              {TRANSACTIONS.map((tx, i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 14px', borderRadius:11, background:'rgba(255,255,255,.02)', border:'1px solid rgba(255,255,255,.05)' }}>
                  <div style={{ width:36, height:36, borderRadius:10, background: tx.type==='in' ? 'rgba(0,208,132,.12)' : 'rgba(239,68,68,.12)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, flexShrink:0 }}>{tx.type==='in' ? '⬇️' : '⬆️'}</div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:'clamp(12px,2vw,14px)', fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{tx.label}</div>
                    <div style={{ fontSize:11, color:'rgba(255,255,255,.35)', marginTop:2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{tx.note} · {tx.date}</div>
                  </div>
                  <div style={{ textAlign:'right', flexShrink:0 }}>
                    <div style={{ fontSize:'clamp(12px,2vw,14px)', fontWeight:700, color: tx.type==='in' ? C.success : C.danger }}>{tx.amount}</div>
                    <div style={{ fontSize:10, color:'rgba(255,255,255,.25)', fontFamily:'monospace' }}>{tx.hash}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right: stats */}
        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
          <div className="card" style={{ padding:'clamp(18px,3vw,24px)' }}>
            <h3 className="syne" style={{ fontSize:15, fontWeight:700, marginBottom:16 }}>This Month</h3>
            {[['💰 Earned','+350 ONT',C.success],['💸 Spent','-45 ONT',C.danger],['🎁 Referrals','+50 ONT',C.magenta]].map(([l,v,c]) => (
              <div key={l} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 0', borderBottom:'1px solid rgba(255,255,255,.05)' }}>
                <span style={{ fontSize:13, color:'rgba(255,255,255,.55)' }}>{l}</span>
                <span style={{ fontSize:14, fontWeight:700, color:c, fontFamily:"'Syne',sans-serif" }}>{v}</span>
              </div>
            ))}
          </div>

          <div className="card" style={{ padding:'clamp(18px,3vw,24px)', background:`linear-gradient(135deg,${C.navy}50,${C.violet}20)` }}>
            <h3 className="syne" style={{ fontSize:15, fontWeight:700, marginBottom:12 }}>About ONT Token</h3>
            <p style={{ fontSize:13, color:'rgba(255,255,255,.5)', lineHeight:1.7, marginBottom:16 }}>Oracle Nexus Token (ONT) powers all transactions on the platform — payments, training, rewards, and governance.</p>
            {[['Network','Solana'],['Contract','7xKp...9mNq'],['Current Rate','1 ONT = $0.15'],['Circulating','42M ONT']].map(([k,v]) => (
              <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid rgba(255,255,255,.05)' }}>
                <span style={{ fontSize:12, color:'rgba(255,255,255,.38)' }}>{k}</span>
                <span style={{ fontSize:12, fontWeight:600, color:'rgba(255,255,255,.75)' }}>{v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ActionModal action={action} onClose={() => setAction(null)} />
    </DashboardLayout>
  );
}
